import { render, staticRenderFns } from "./HeaderRestaurantDescription.vue?vue&type=template&id=2f397619"
import script from "./HeaderRestaurantDescription.vue?vue&type=script&lang=js"
export * from "./HeaderRestaurantDescription.vue?vue&type=script&lang=js"
import style0 from "./HeaderRestaurantDescription.vue?vue&type=style&index=0&id=2f397619&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports